module.exports = __webpack_public_path__ + "static/junglesmarts-8995f6091c41e8add7d4089758ed8a44.jpg";